<div role="dialog" aria-labelledby="modalContactInfo" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body custom-scroll-bar">
        <div class="text-center">
          <!-- Vou trabalhar aqui -->
          <img
            class="img-thumbnail avatar-lg rounded-circle"
            [src]="getContactImage($safeNavigationMigration(attendance?.contact))"
            [alt]="attendance?.contact?.name || ('attendance.contactInfo.contactPhotoAlt' | translate)"
            (error)="onImageError($event)"
            (click)="openPreview()"
            />

          <!-- Overlay de preview -->
          @if (isPreviewOpen) {
            <div
              class="img-preview-overlay"
              (click)="closePreview()"
              >
              <img
                class="img-preview-img"
                [src]="getContactImage($safeNavigationMigration(attendance?.contact))"
                [alt]="attendance?.contact?.name || ('attendance.contactInfo.contactPhotoLargeAlt' | translate)"
                />
            </div>
          }

          <h4>{{ $safeNavigationMigration(attendance?.contact?.name) | truncate: 15 }}</h4>

          <h5>{{ $safeNavigationMigration(attendance?.contact?.phone) | phone }}</h5>

          <softphone-widget class="d-block mt-2" [attendance]="attendance" />

          <p class="text-muted mt-2 font-14">
            <strong>{{
              getTranslatedStatusAttendance($safeNavigationMigration(attendance?.status))
            }}</strong>
          </p>
          <button class="button-show-info" (click)="toggleContactInfo()">
            <i
              class="ri-arrow-down-s-line"
              [ngClass]="
                !contactInfo ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'
              "
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (attendance) {
  <div class="contact-info-main">
    <div
      [@slideInOut]="contactInfoState"
      class="show-contact-info custom-scroll-bar"
      >
      @if (attendance.contact && getAddLeadsCurrentUser()) {
        <button
          class="btn btn-primary btn-sm mt-1"
          (click)="edit(attendance.contact)"
          >
          <i class="ri-edit-2-line"></i>
          {{ 'attendance.contactInfo.edit' | translate }}
        </button>
      }

      @if (attendance?.contact?.email) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.email' | translate }}</strong>
        </p>
        <p>
          {{ attendance?.contact?.email }}
        </p>
      }

      @if (attendance?.metadata?.webchat?.startUrl) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.webchatStartUrl' | translate }}</strong>
        </p>
        <p class="text-truncate">
          <a [href]="attendance.metadata.webchat.startUrl" target="_blank" rel="noopener">
            {{ attendance.metadata.webchat.startUrl }}
          </a>
        </p>
      }

      @if (attendance?.contact?.contactCompany) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.company' | translate }}</strong>
        </p>
        <p>
          {{ attendance?.contact?.contactCompany }}
        </p>
      }

      @if (attendance?.contact?.contactPosition) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.position' | translate }}</strong>
        </p>
        <p>
          {{ attendance?.contact?.contactPosition }}
        </p>
      }

      @if (attendance?.contact?.phone) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.phone' | translate }}</strong>
        </p>
        <p>
          {{ getMaskedPhone($safeNavigationMigration(attendance?.contact?.phone)) }}
        </p>
      }

      @if (attendance?.contact?.whatsapp?.username) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.whatsappUsername' | translate }}</strong>
        </p>
        <p>
          {{ "@" + attendance?.contact?.whatsapp?.username }}
        </p>
      }

      @if (attendance?.contact?.whatsapp?.bsuid) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.bsuid' | translate }}</strong>
        </p>
        <p class="text-muted font-13">
          {{ attendance?.contact?.whatsapp?.bsuid }}
        </p>
      }

      @if (attendance?.contact?.groups.length > 0) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.contactGroups' | translate }}</strong>
        </p>
        <p class="d-flex flex-wrap gap-1">
          @for (group of getGroups($safeNavigationMigration(attendance?.contact?.groups)); track group) {
            <span class="badge badge-success-lighten p-1 font-14">{{
              group
            }}</span>
          }
        </p>
      }

      @if (attendance?.contact?.tin) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.cpf' | translate }}</strong>
        </p>
        <p>
          {{ getFormatTin($safeNavigationMigration(attendance?.contact?.tin)) }}
        </p>
      }

      @if (attendance?.contact?.gender) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.gender' | translate }}</strong>
        </p>
        <p>
          {{ getFormatGender($safeNavigationMigration(attendance?.contact?.gender)) }}
        </p>
      }

      @if (attendance?.contact?.birthDate) {
        <p class="mt-3 mb-1">
          <strong>{{ 'attendance.contactInfo.birthDate' | translate }}</strong>
        </p>
        <p>
          {{
          $safeNavigationMigration(attendance?.contact?.birthDate)
          | timezoneDate: "DD/MM/YYYY" : getTimezoneCompanyCurrentUser()
          }}
        </p>
      }

      <p class="mt-3 mb-1">
        <strong>{{ 'attendance.contactInfo.address' | translate }}</strong>
      </p>
      <p>
        {{ getFormatAddres(attendance) }}
      </p>
    </div>
  </div>
}
